<div class="account-activity">
  <div class="account-activity-row-top">
    <div class="account-activity-col-left">
      <h4 class="account-activity-subtitle">{{accountActivityValue}}</h4>
   
    </div>
    <img src="assets/img/account-activity-icn-window.png" class="account-activity-icn-window-close account-activity-icn-window" (click)="close()" />
  </div>

  <!-- Tab Bar -->
  <div class="trade-details-tabs">
    <button class="trade-details-tab" [class.active]="activeTab === 'account-activity'" (click)="setTab('account-activity')">Account Activity</button>
    <span class="trade-details-tab-tooltip-trigger" [attr.title]="isD365NotesDisabled() ? unsupportedReportMessage : null">
      <button class="trade-details-tab"
        [class.active]="activeTab === 'd365-notes'"
        [disabled]="isD365NotesDisabled()"
        (click)="setTab('d365-notes')">D365 Notes{{ hasLoadedNotesCount && crmNotes.length > 0 ? ' (' + crmNotes.length + ')' : '' }}</button>
    </span>
    <span class="trade-details-tab-tooltip-trigger" [attr.title]="isD365TasksDisabled() ? unsupportedReportMessage : null">
      <button class="trade-details-tab"
        [class.active]="activeTab === 'd365-tasks'"
        [disabled]="isD365TasksDisabled()"
        (click)="setTab('d365-tasks')">D365 Tasks{{ d365TasksCount > 0 ? ' (' + d365TasksCount + ')' : '' }}</button>
    </span>
    <span class="trade-details-tab-tooltip-trigger" [attr.title]="isInteractionsDisabled() ? unsupportedReportMessage : null">
      <button class="trade-details-tab"
        [class.active]="activeTab === 'interactions'"
        [disabled]="isInteractionsDisabled()"
        (click)="setTab('interactions')">Interactions{{ d365InteractionsCount > 0 ? ' (' + d365InteractionsCount + ')' : '' }}</button>
    </span>
  </div>

  <!-- Account Activity Tab -->
  <div class="table-scroll-wrapper" *ngIf="activeTab === 'account-activity'">
    
    <br/>
    <table mat-table [dataSource]="trades">
      <!-- Dynamic columns -->
      <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col.field">
        <th mat-header-cell *matHeaderCellDef (click)="applyOrderBy(col.field)"
          class="pointer hover-sortable-header" [style.text-align]="getAlignment(col)">
          {{col.headerName}}
          <mat-icon class="p-l-5 dark-blue sort-icon" inline=true
            *ngIf="orderByField === col.field && orderBy === 'ASC'">arrow_upward</mat-icon>
          <mat-icon class="p-l-5 dark-blue sort-icon" inline=true
            *ngIf="orderByField === col.field && orderBy === 'DESC'">arrow_downward</mat-icon>
        </th>
        <td mat-cell *matCellDef="let element" [title]="element[col.field]" [style.text-align]="getAlignment(col)">
          <div [class.cell-text]="!col.uiDataType">{{formatValue(element[col.field], col)}}<span *ngIf="col.parenthField && element[col.parenthField]"> ({{element[col.parenthField]}})</span><span *ngIf="col.subField && isTimestamp(col)"> {{formatSubField(element[col.subField], col)}}</span></div>
          <div *ngIf="col.subField && !isTimestamp(col)" class="sub-field-text">{{formatSubField(element[col.subField], col)}}</div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnNames; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnNames;"></tr>
    </table>
  </div>

  <!-- D365 Notes Tab -->
  <div class="notes-panel" *ngIf="activeTab === 'd365-notes' && !isD365NotesDisabled()">
    <div class="notes-actions-row">
      <button type="button" class="notes-toolbar-btn accent" (click)="toggleAddNote()">
        <mat-icon>{{ isAddNoteOpen ? 'close' : 'add' }}</mat-icon>
        {{ isAddNoteOpen ? 'Cancel' : 'Add Note' }}
      </button>
      <button type="button" class="sort-chip" (click)="toggleNoteSort()" [title]="notesSortOrder === 'desc' ? 'Sorted: New - Old' : 'Sorted: Old - New'">
        Sort: {{ notesSortOrder === 'desc' ? 'New - Old' : 'Old - New' }}
        <mat-icon>swap_vert</mat-icon>
      </button>
    </div>

    <!-- Success banner (shown outside the form after close) -->
    <div class="notes-banner info" style="margin-top: 12px;" *ngIf="addNoteSuccessMessage && !isAddNoteOpen">{{ addNoteSuccessMessage }}</div>

    <!-- Add Note Form -->
    <div class="add-note-section" *ngIf="isAddNoteOpen">
      <div class="add-note-header">New Note</div>
      <form [formGroup]="addNoteForm" (ngSubmit)="submitNote()" class="add-note-form">

        <mat-form-field appearance="outline" class="add-note-field">
          <mat-label>Note Title</mat-label>
          <input matInput formControlName="noteTitle" maxlength="200" />
          <mat-error *ngIf="addNoteForm.get('noteTitle')?.invalid && addNoteForm.get('noteTitle')?.touched">
            Title is required
          </mat-error>
        </mat-form-field>

        <div class="add-note-field">
          <app-ckeditor
            [data]="addNoteForm.get('noteBody')?.value || ''"
            [height]="'150px'"
            (contentChanged)="onNoteBodyChanged($event)">
          </app-ckeditor>
          <div class="add-note-editor-error"
               *ngIf="addNoteForm.get('noteBody')?.invalid && addNoteForm.get('noteBody')?.touched">
            Description is required
          </div>
        </div>

        <div class="add-note-field add-note-attachment-field">
          <div class="add-note-editor-label">Attachment</div>
          <input
            #addNoteAttachmentInput
            type="file"
            class="add-note-file-input-hidden"
            (change)="onAttachmentSelected($event)"
            [disabled]="isSubmittingNote" />
          <div class="add-note-file-picker">
            <button
              type="button"
              class="add-note-file-trigger"
              (click)="openAttachmentPicker()"
              [disabled]="isSubmittingNote">
              Choose File
            </button>
            <ng-container *ngIf="selectedAttachments.length; else noNoteAttachmentSelected">
              <div class="add-note-attachment-meta">
                <span class="add-note-attachment-name">{{ selectedAttachments[0].name }}</span>
                <span class="add-note-attachment-size">({{ formatAttachmentSize(selectedAttachments[0].size) }})</span>
                <button type="button" class="note-expand" (click)="removeAttachment(selectedAttachments[0].id)">Remove</button>
              </div>
            </ng-container>
            <ng-template #noNoteAttachmentSelected>
              <span class="add-note-attachment-empty">No file chosen</span>
            </ng-template>
          </div>
          <div class="add-note-attachment-help">Max file size: 5MB</div>
        </div>

        <div *ngIf="addNoteErrorMessage" class="notes-banner error">{{ addNoteErrorMessage }}</div>
        <div *ngIf="addNoteSuccessMessage" class="notes-banner info">{{ addNoteSuccessMessage }}</div>

        <div class="add-note-actions">
          <button type="submit" class="add-note-btn save" [disabled]="addNoteForm.invalid || isSubmittingNote">
            {{ isSubmittingNote ? 'Saving...' : 'Save Note' }}
          </button>
          <button type="button" class="add-note-btn cancel" (click)="toggleAddNote()">Cancel</button>
        </div>
      </form>
    </div>

    <!-- Notes List -->
    <div class="notes-list-container">

      <div *ngIf="notesLoadErrorMessage" class="notes-banner error">{{ notesLoadErrorMessage }}</div>
      <div *ngIf="noteAttachmentErrorMessage" class="notes-banner error">{{ noteAttachmentErrorMessage }}</div>

      <div *ngIf="crmNotes.length === 0 && !(isLoadingNotes$ | async) && !notesLoadErrorMessage"
           class="notes-banner info" style="margin-top:16px">
        No notes found for this client.
      </div>

      <div class="notes-list" *ngIf="crmNotes.length > 0">
        <ng-container *ngFor="let note of crmNotes; let i = index; trackBy: trackNoteById">
          <div *ngIf="i > 0" class="note-divider"></div>
          <div class="note-item">

            <div class="note-item-header">
              <div class="note-author-section">
                <div class="note-avatar">{{ getNoteInitials(note.ownerName) }}</div>
                <div class="note-author-info">
                  <span class="note-author-name">{{ note.ownerName }}</span>
                  <span class="note-author-date">{{ formatNoteDate(note.createdon) }}</span>
                </div>
              </div>
              <div class="note-regarding" *ngIf="getRegardingName(note)">
                Regarding: <span class="note-regarding-name">{{ getRegardingName(note) }}</span>
              </div>
            </div>

            <div class="note-content-section">
              <div class="note-title-row" *ngIf="note.subject">{{ note.subject }}</div>
              <div #noteBodyEl class="note-body" [class.clamped]="!note.isExpanded" [innerHTML]="sanitizeNoteHtml(note.notetext)"></div>
              <button class="note-expand" type="button" *ngIf="note.showSeeMore || note.isExpanded" (click)="toggleNoteExpand(note)">
                {{ note.isExpanded ? 'See less' : 'See more' }}
              </button>
              <div class="note-attachment" *ngIf="note.filename">
                <mat-icon>attach_file</mat-icon>
                <button
                  type="button"
                  class="note-attachment-link"
                  [disabled]="isDownloadingAttachment$ | async"
                  [title]="(isDownloadingAttachment$ | async) ? 'Downloading attachment...' : 'Download attachment - ' + note.filename"
                  (click)="downloadNoteAttachment(note)">
                  {{ note.filename }}
                </button>
              </div>
            </div>

          </div>
        </ng-container>
      </div>

    </div>

  </div>
  <div class="notes-panel" *ngIf="activeTab === 'd365-tasks' && !isD365TasksDisabled()">
    <app-trade-details-tasks
      [partyDetails]="partyDetails"
      (tasksCountChange)="onTasksCountChange($event)"></app-trade-details-tasks>
  </div>
  <div class="notes-panel" *ngIf="activeTab === 'interactions' && !isInteractionsDisabled()">
    <app-trade-details-interactions
      [partyDetails]="partyDetails"
      (interactionsCountChange)="onInteractionsCountChange($event)"></app-trade-details-interactions>
  </div>
</div>
